import { message } from 'antd';
import { ConfigOptions } from 'antd/es/message';
import 'antd/es/message/style/index.css';
import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import './index.less';

const { warning, warn, loading, config, destroy, open } = message;

const ErrorIcon = (
    <IconFont
        fontSize={16}
        color="var(--content-system-info-icon-warning)"
        name="ExclamationMarkCircleBoldFill"
        style={{
            marginRight: 8,
        }}
    />
);

const InfoIcon = (
    <IconFont
        fontSize={16}
        color="var(--content-system-info-icon-regular)"
        name="InfoCircleBoldFill"
        style={{
            marginRight: 8,
        }}
    />
);

const SuccessIcon = (
    <IconFont
        fontSize={16}
        color="var(--content-system-info-icon-success)"
        name="CheckCircleFillBold"
        style={{
            marginRight: 8,
        }}
    />
);

interface MessageConfigOptions extends ConfigOptions {
    content: React.ReactNode;
    className?: string;
    icon?: React.ReactNode;
}

const Message = {
    error(config: MessageConfigOptions | string) {
        if (typeof config === 'string') {
            return open({
                type: 'error',
                content: config,
                icon: ErrorIcon,
            });
        }
        return open({
            type: 'error',
            ...config,
            icon: config.icon ?? ErrorIcon,
        });
    },
    info(config: MessageConfigOptions | string) {
        if (typeof config === 'string') {
            return open({
                type: 'info',
                content: config,
                icon: InfoIcon,
            });
        }
        return open({
            type: 'info',
            ...config,
            icon: config.icon ?? InfoIcon,
        });
    },
    warning,
    warn,
    success(config: MessageConfigOptions | string) {
        if (typeof config === 'string') {
            return open({
                type: 'success',
                content: config,
                icon: SuccessIcon,
            });
        }
        return open({
            type: 'success',
            ...config,
            icon: config.icon ?? SuccessIcon,
        });
    },
    loading,
    config,
    destroy,
    open,
};

Message.config({
    maxCount: 1,
});

export default Message;
